import axios from 'axios';

export default {
  data() {
    return {};
  },
  methods: {
    getVideoIdFromEmbedVideo(embedVideo) {
      return embedVideo.substring(embedVideo.lastIndexOf('/') + 1);
    },

    getVideosList(elem, videoId) {
      return axios.get(`https://vimeo.com/api/oembed.json?url=${elem.embedVideo}&id=${videoId}`);
    },

    getVideoThumbs(array) {
      let embedThumbs = [];
      array.forEach(elem => {
        const videoId = this.getVideoIdFromEmbedVideo(elem.embedVideo);
        this.getVideosList(elem, videoId).then(res => {
          if (res.data) {
            embedThumbs.push({
              ...elem,
              thumb: res.data.thumbnail_url_with_play_button,
              thumbWithoutPlayButton: res.data.thumbnail_url,
            });
          }
        });
      });
      return embedThumbs;
    },

    async getVideoThumbsAsync(array) {
      let embedThumbs = [];

      for (const elem of array) {
        if (!elem.embedVideo) {
          continue;
        }

        try {
          // Ensure the URL is properly formatted
          let videoUrl = elem.embedVideo;
          if (!videoUrl.includes('vimeo.com')) {
            videoUrl = `https://vimeo.com/${this.getVideoIdFromEmbedVideo(elem.embedVideo)}`;
          }

          const res = await this.getVideosList(
            elem,
            this.getVideoIdFromEmbedVideo(elem.embedVideo),
          );

          if (res.data) {
            embedThumbs.push({
              ...elem,
              thumb: res.data.thumbnail_url_with_play_button,
              thumbWithoutPlayButton: res.data.thumbnail_url,
            });
          } else if (elem.image) {
            // Use fallback image if no thumbnail data received
            embedThumbs.push({
              ...elem,
              thumb: elem.image,
              thumbWithoutPlayButton: elem.image,
            });
          }
        } catch (error) {
          // Use fallback image if Vimeo API call fails
          if (elem.image) {
            embedThumbs.push({
              ...elem,
              thumb: elem.image,
              thumbWithoutPlayButton: elem.image,
            });
          }
        }
      }

      return embedThumbs;
    },
  },
};
